import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import { Route } from "react-router-dom";
import { ResetPasswordForm } from "../../components/ResetPasswordForm";

@AttributeGroup({ title: 'ResetPasswordPage', blockName: 'ResetPasswordPage', module: 'auth' })
export class ResetPasswordPageAttributes extends Attribute {


}

const ResetPasswordPageTheme = styled.div((props: { attributes: ResetPasswordPageAttributes }) => `

    ${props.attributes.toCSS()}

    padding: 20px;

`);

function ResetPasswordPage(props: ComponentProps<ResetPasswordPageAttributes>) {
    return (
        <Route exact path={'/resetPassword'} render={({ location }) => {
            return <ResetPasswordPageTheme attributes={props.attributes}>
                <ResetPasswordForm></ResetPasswordForm>
            </ResetPasswordPageTheme>
        }} />
    )
}


ResetPasswordPage.prototype.Props = ResetPasswordPageAttributes;


export default ResetPasswordPage;